import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../hooks/AuthenticateContext';

interface UserSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const UserSidebar: React.FC<UserSidebarProps> = ({ isOpen, onClose }) => {
  const { user, logout } = useAuth();

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/20 z-40"
            onClick={onClose}
          />
          
          {/* Sidebar */}
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
            className="fixed top-16 right-0 h-[calc(100vh-64px)] w-80 bg-[#003366] text-white z-50 shadow-lg overflow-y-auto border-t border-[#004080]"
          >
            <div className="p-6 flex flex-col h-full">
              <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-1">
                  <span className="text-base font-medium">Nome</span>
                  <span className="text-sm text-gray-300 uppercase">{user?.nome || "---"}</span>
                </div>

                <div className="flex flex-col gap-1">
                  <span className="text-base font-medium">E-mail</span>
                  <span className="text-sm text-gray-300">{user?.email || "---"}</span>
                </div>

                <div className="flex flex-col gap-1">
                  <span className="text-base font-medium">Grupo</span>
                  <span className="text-sm text-gray-300 uppercase">{user?.grupo || "---"}</span>
                </div>
              </div>

              <div className="mt-auto pt-6 pb-4 flex flex-col gap-6">
                <div>
                  <h3 className="text-lg font-medium mb-4">Conta do Usuário</h3>
                  <ul className="space-y-4">
                    <li>
                      <a href="#" className="text-gray-300 hover:text-white text-sm block">
                        Alterar senha
                      </a>
                    </li>
                    <li>
                      <a 
                        href="/termos.pdf" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-white text-sm block"
                      >
                        Termos de uso e políticas de privacidade
                      </a>
                    </li>
                  </ul>
                </div>

                <button 
                  className="text-white hover:text-gray-300 font-medium text-base text-left"
                  onClick={logout}
                >
                  Sair
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default UserSidebar;
